/**
 * Redux entity adapters for every collection the billing feature tracks —
 * billing accounts with their agreements and notes, invoices, device and
 * feature pricing, the device/feature billing categories, and prepaid
 * coverages.
 *
 * Extracted so each per-entity slice module and its selectors share one
 * adapter instance (a selector's getSelectors must be built from the same
 * adapter that shaped the state), and so cross-entity reducer cases — loading
 * a billing account also upserts its notes and agreements — can reach every
 * adapter without a circular import between the entity modules.
 */
import { createEntityAdapter } from '@reduxjs/toolkit';

export const deviceCategoriesAdapter = createEntityAdapter();
export const devicePricingAdapter = createEntityAdapter();
export const featurePricingAdapter = createEntityAdapter();
export const billingAccountsAdapter = createEntityAdapter();
export const billingAccountAgreementsAdapter = createEntityAdapter();
export const billingAccountNotesAdapter = createEntityAdapter();
export const invoicesAdapter = createEntityAdapter();
export const prepaidCoveragesAdapter = createEntityAdapter();
